<script lang="ts">
    import { cx } from '$lib/utils/cx.js';
    import { type createDropdownMenu, melt } from '@melt-ui/svelte';

    export let href: string | null = null;
    export let icon: string = '';
    export let reload: boolean = true;

    export let meltMenu: ReturnType<typeof createDropdownMenu>;

    const {
        elements: { item },
    } = meltMenu;
</script>

<li
    class="flex items-center gap-x-[12px] relative hover:bg-gray-200 focus-within:bg-gray-200 px-[24px] py-[8px]"
>
    <i class={cx(icon, 'text-22 text-brand-blue')}></i>
    <a
        use:melt={$item}
        {href}
        data-sveltekit-reload={reload ? true : 'off'}
        class="block text-gray-800 hover:text-black no-underline text-14/[20px] stretched-link cursor-pointer outline-none"
    >
        <slot />
    </a>
</li>
